"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _getIcon = _interopRequireDefault(require("../utils/getIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ServiceType = function ServiceType(_ref) {
  var serviceType = _ref.serviceType,
    level = _ref.level,
    showIcon = _ref.showIcon,
    iconColor = _ref.iconColor;
  var itemClass = function itemClass() {
    return (0, _classnames["default"])({
      'ui-service-type': true,
      'ui-service-type__parent': level <= 0,
      'ui-service-type__child': level > 0
    });
  };
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: itemClass()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-service-type__item"
  }, showIcon && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-service-type__item-icon"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    icon: (0, _getIcon["default"])(serviceType.code),
    color: iconColor,
    size: 18
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ui-service-type__item-name"
  }, serviceType.name)), (0, _lodash.has)(serviceType, 'children') && !(0, _lodash.isEmpty)(serviceType.children) && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "ui-service-type__item-children list-unstyled"
  }, serviceType.children.map(function (st) {
    return /*#__PURE__*/_react["default"].createElement(ServiceType, {
      key: "ui-service-type-".concat(level, "-").concat(st.code),
      serviceType: st,
      level: level + 1,
      showIcon: false,
      iconColor: iconColor
    });
  })));
};
ServiceType.propTypes = {
  iconColor: _propTypes["default"].string.isRequired,
  level: _propTypes["default"].number.isRequired,
  serviceType: _propTypes["default"].shape({
    children: _propTypes["default"].array,
    code: _propTypes["default"].string.isRequired,
    name: _propTypes["default"].string.isRequired
  }).isRequired,
  showIcon: _propTypes["default"].bool.isRequired
};
ServiceType.defaultProps = {
  serviceType: _propTypes["default"].shape({
    children: undefined
  })
};
var _default = exports["default"] = ServiceType;